import { Particle } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { Explode } from "../behaviors/Explode";
import { adjustColor } from "../../utils/color";
import { Fire } from "./Fire";

export class Gunpowder extends Particle {
    static baseColor = 0x444444; // Dark Grey

    constructor() {
        super({
            name: "Gunpowder",
            color: adjustColor(Gunpowder.baseColor, 10),
            behaviors: [
                new MovesDown(),
                new TemperatureNormalization(20, 0.05),
                // 爆炸：温度达到 200 时触发，半径 3，50% 概率填充空位
                new Explode(200, 30, () => new Fire(), 0.5)
            ],
            temperature: 20,
            minTemp: -273,
            maxTemp: 1000,
            props: {
                isPowder: true,
                isFlammable: false, // 必须为 false，否则会被 Fire 的 SpreadFire 行为直接作为燃料消耗，而不触发爆炸
                thermalConductivity: 3.0 // 导热性高，容易受热引爆
            }
        });
    }
}
